import React from 'react';

const Footer = ({ clientName = "Client Name" }) => (
    <footer className="footer bg-light mt-5 ">
        <div className="copy-right_text">
            <div className="container">
                <div className="footer_border" style={{ borderTop: "1px solid #eaeaea", marginBottom: "15px" }}></div>
                <div className="row">
                    <div className="col-xl-12">
                        <p className="copy_right text-center mb-0">
                            Copyright &copy;{new Date().getFullYear()} All rights reserved www.managerecalls.com
                            &nbsp;
                            
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;